import React, { useReducer, useState } from 'react';
import {
  Form,
  Row,
  Col,
  Input,
  Button,
  Upload,
  Select,
  Divider,
  Typography,
  Space,
  message,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import useStore from '../../store/useStore';
import AddressUnitsSelector from '../../components/common/AddressUnitSelector';
import _ from 'lodash';
import { commonRegExp } from '../../utils/index';
import { addressStyleProps } from '../../utils/format';
import StepFooter from '../../components/stepFooter/StepFooter';

const { Option } = Select;
const { Title } = Typography;

/** Талбарууд картын бүтэн өргөнөөр сунахгүй — зүүн талд багцлагдана */
const FORM_MAX_WIDTH = 960;

const actions = {
  imageChange: 'IMAGE_CHANGE',
};

const initialState = {
  idCardFront: null,
  idCardBack: null,
};

function reducer(state, action) {
  switch (action.type) {
    case actions.imageChange: {
      const { key, file } = action.payload;

      return {
        ...state,
        [key]: file,
      };
    }
    default:
      return state;
  }
}

const CitizenForm = ({
  onSubmit,
  categories,
  setMerchantAddress,
  submitting = false,
  categoriesLoading = false,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState, undefined);
  const [autoFill] = useStore((state) => [state?.user?.autoFill]);
  const [addressArray, setAddressArray] = useState([]);
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const isValidFileSize = (file) => file.size < 5000001;

  const beforeUpload = (file) => {
    if (!isValidFileSize(file)) {
      message.error('Файлын хэмжээ 5mb -аас бага байх ёстой!');
    }

    return isValidFileSize(file);
  };
  const onHandleAddress = (value) => {
    setAddressArray(value);
    setMerchantAddress(value);
  };
  return (
    <Form onFinish={onSubmit} autoComplete="off" layout="vertical" initialValues={autoFill ?? {}}>
      <div style={{ maxWidth: FORM_MAX_WIDTH }}>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Таны нэр"
              name="name"
              rules={[{ required: true, message: 'Нэр оруулна уу' }]}
            >
              <Input placeholder="Таны нэр" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Регистрийн дугаар"
              name="registrationNumber"
              rules={[
                {
                  required: true,
                  message: 'Регистрийн дугаар оруулна уу',
                },
                {
                  pattern: new RegExp(commonRegExp.registrationNumber),
                  message: 'Регистрийн дугаар буруу байна.',
                },
              ]}
            >
              <Input placeholder="УУ12345678" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="brandLogo"
              label="Бизнесийн лого"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              rules={[{ required: true, message: 'Бизнесийн лого оруулна уу' }]}
            >
              <Upload
                listType="picture"
                beforeUpload={() => false}
                multiple={false}
                maxCount={1}
                style={{ width: '100%', maxHeight: '100%' }}
              >
                <Button icon={<UploadOutlined />} block>
                  Зураг хуулах
                </Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="category"
              label="Үйл ажиллагааны чиглэл"
              rules={[{ required: true, message: 'Бүтцийн зураг оруулна уу' }]}
            >
              <Select loading={categoriesLoading}>
                {categories.map((option) => {
                  return (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="phoneNumber"
              label="Утас"
              rules={[{ required: true, message: 'Утас оруулна уу' }]}
            >
              <Input placeholder={'99999999'} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="email"
              label="И-Мэйл"
              rules={[{ required: true, message: 'И-Мэйл оруулна уу' }]}
            >
              <Input placeholder={'Таны и-мэйл'} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="website"
              label="Вэбсайт"
              rules={[{ required: false, message: 'Вэбсайт оруулна уу' }]}
            >
              <Input placeholder={'www.example.com'} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="address"
              label="Бүртгэлтэй хаяг"
              rules={[{ required: true, message: 'Бүртгэлтэй хаяг оруулна уу' }]}
            >
              <Input placeholder={'УБ...'} />
            </Form.Item>
          </Col>
        </Row>
        <Divider />
        <Title level={5}>Иргэний үнэмлэхний зураг</Title>
        <Row gutter={16} style={{ marginTop: 20 }}>
          <Col>
            <Form.Item
              name="idCardFront"
              label="Урд зураг"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              rules={[
                { required: true, message: 'Иргэний үнэмлэхний урд талын зургийг оруулна уу' },
              ]}
              shouldUpdate
            >
              <Upload
                // listType="picture-card"
                showUploadList={false}
                beforeUpload={beforeUpload}
                maxCount={1}
                multiple={false}
                onChange={({ fileList: [{ originFileObj: file }] }) => {
                  if (isValidFileSize(file)) {
                    dispatch({
                      type: actions.imageChange,
                      payload: {
                        file,
                        key: 'idCardFront',
                      },
                    });
                  }
                }}
              >
                {state.idCardFront ? (
                  <Space
                    size={16}
                    style={{ background: '#fff', padding: '4px 16px', height: '100%' }}
                  >
                    {state.idCardFront?.type === 'application/pdf' ? (
                      <embed
                        src={URL.createObjectURL(state.idCardFront)}
                        style={{ width: 100 }}
                        alt=""
                      />
                    ) : (
                      <img
                        src={URL.createObjectURL(state.idCardFront)}
                        style={{ width: 100 }}
                        alt="Иргэний үнэмлэхний урд тал"
                      />
                    )}
                    <div>{_.truncate(state.idCardFront?.name, { length: 13 }) ?? ''}</div>
                  </Space>
                ) : (
                  <Button
                    style={{
                      height: '100px',
                      width: '100px',
                      borderRadius: '6px',
                      marginTop: '6px',
                    }}
                    type="dashed"
                  >
                    Хуулах
                  </Button>
                )}
              </Upload>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item
              name="idCardBack"
              label="Ард зураг"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              rules={[
                { required: true, message: 'Иргэний үнэмлэхний ард талын зургийг оруулна уу' },
              ]}
              shouldUpdate
            >
              <Upload
                // listType="picture-card"
                showUploadList={false}
                beforeUpload={beforeUpload}
                maxCount={1}
                multiple={false}
                onChange={({ fileList: [{ originFileObj: file }] }) => {
                  if (isValidFileSize(file)) {
                    dispatch({
                      type: actions.imageChange,
                      payload: {
                        file,
                        key: 'idCardBack',
                      },
                    });
                  }
                }}
              >
                {state.idCardBack ? (
                  <Space
                    size={16}
                    style={{ background: '#fff', padding: '4px 16px', height: '100%' }}
                  >
                    {state.idCardBack?.type === 'application/pdf' ? (
                      <embed
                        src={URL.createObjectURL(state.idCardBack)}
                        style={{ width: 100 }}
                        alt=""
                      />
                    ) : (
                      <img
                        src={URL.createObjectURL(state.idCardBack)}
                        style={{ width: 100 }}
                        alt="Иргэний үнэмлэхний ард тал"
                      />
                    )}
                    <div>{_.truncate(state.idCardBack?.name, { length: 13 }) ?? ''}</div>
                  </Space>
                ) : (
                  <Button
                    style={{
                      height: '100px',
                      width: '100px',
                      borderRadius: '6px',
                      marginTop: '6px',
                    }}
                    type="dashed"
                  >
                    Хуулах
                  </Button>
                )}
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Divider />
        <Title level={5}>Салбарын мэдээлэл</Title>
        <Row gutter={16} style={{ marginTop: 20 }}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Салбарын нэр"
              name="branchName"
              rules={[
                {
                  required: true,
                  message: 'Салбарын нэр оруулна уу',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Салбарын утас"
              name="branchPhoneNumber"
              rules={[
                {
                  required: true,
                  message: 'Салбарын утас оруулна уу',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <AddressUnitsSelector
          selectedUnits={addressArray}
          onChange={onHandleAddress}
          styleProps={addressStyleProps}
        />
        <Row gutter={16} style={{ marginTop: 20 }}>
          <Col xs={24} xl={16}>
            <Form.Item
              label="Салбарын дэлгэрэнгүй хаяг"
              name="branchAddressDetail"
              rules={[
                {
                  required: false,
                  message: 'Салбарын дэлгэрэнгүй хаяг оруулна уу',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </div>
      <StepFooter submitText="Хүсэлт илгээх" loading={submitting} />
    </Form>
  );
};

export default CitizenForm;
